import Vue from 'vue';
import VueRouter from 'vue-router';

// 注册 vue-router (需在 router 实例创建之前调用)
Vue.use(VueRouter);

// 引入首页组件
import Index from '../views/index.vue';


// 配置路由规则
const routes = [
    {
        path: '/', // 路由路径;    注意: hash 模式下, 路由路径要使用小写
        name: 'index', // 路由名称;  可选;  name 值必须保持唯一性
        component: Index, // 展示的组件
    },
    {
        path: '/pinpaijianshe/:cate_id/:id',
        name:'pinpaijianshe',
        component: () => import('../views/pinpaijianshe.vue'), // 懒加载写法, 访问该组件时再获取
        // 一般情况下, 除初始页面以外的其他页面都应该使用懒加载
    },
    {
        path:"/zixunzhongxin/:cate_id/:id",
        name:"zixunzhongxin",
        component:()=>import("../views/zixunzhongxin.vue")
    },
    {
        path:"/zixuninfo/:id/:cate_title/:children_title",
        name:"zixuninfo",
        component:()=>import("../views/zixuninfo.vue")
    },
    {
        path:"/jinguojiazheng/:cate_id/:id",
        name:"jinguojiazheng",
        component:()=>import("../views/jinguojiazheng.vue")
    },
    {
        path:"/kechengzhongxin/:cate_id/:id",
        name:"kechengzhongxin",
        component:()=>import("../views/kechengzhongxin.vue")
    },
    {
        path:"/kechenginfo/:id/:cate_title/:children_title",
        name:"kechenginfo",
        component:()=>import("../views/kechenginfo.vue")
    },
    {
        path:"/jiazhengxianfeng/:cate_id/:id",
        name:"jiazhengxianfeng",
        component:()=>import("../views/jiazhengxianfeng.vue")
    },
    {
        path:"/xianfenginfo/:id/:cate_title/:children_title",
        name:"xianfenginfo",
        component:()=>import("../views/xianfenginfo.vue")
    },
    {
        path:"/pinpaiinfo/:id/:cate_title/:children_title",
        name:"pinpaiinfo",
        component:()=>import("../views/pinpaiinfo.vue")
    },
    {
        path:"/jiazhengfuwu/:id",
        name:"jiazhengfuwu",
        component:()=>import("../views/jiazhengfuwu.vue")
    },
    {
        path:"/fuwuinfo/:id",
        name:"fuwuinfo",
        component:()=>import("../views/fuwuinfo.vue")
    },
    {
        path:"/zhengzhifagui/:id",
        name:"zhengzhifagui",
        component:()=>import("../views/zhengzhifagui.vue")
    },
    {
        path:"/faguiinfo/:id",
        name:"faguiinfo",
        component:()=>import("../views/faguiinfo.vue")
    },
    {
        path:"/about/:id",
        name:"about",
        component:()=>import("../views/about.vue")
    },
    {
        path:"/indexlist/:cate_title/:cate_id",
        name:"indexlist",
        component:()=>import("../views/indexlist.vue")
    },
    {
        path:"/info/:id/:cate_title",
        name:"info",
        component:()=>import("../views/info.vue")
    },
    {
        path:"/jinguoinfo/:id/:cate_title/:children_title",
        name:"jinguoinfo",
        component:()=>import("../views/jinguoinfo1.vue")
    },{
        path:"/search/:key",
        name:"search",
        component:()=>import("../views/search.vue")
    },{
        path:"/searchinfo/:id/:key",
        name:"searchinfo",
        component:()=>import("../views/searchinfo")
    }
];

// 创建 router 实例
const router = new VueRouter({ routes });

// 导出 router 实例
export default router;